import { Injectable } from "@angular/core";
import { Community, CommunityType } from "./community.model";
import { HttpClient, HttpParams } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { getCommunityModel } from "src/app/_models/community-request.model";
import { CreateDescriptionDto } from "./community-description-ai/community-ai.model";
import { BehaviorSubject } from "rxjs";
import { AppModule } from "../app.module";
import { Modules } from "src/app/_helpers/module";

const url = environment.api;

@Injectable({
  providedIn: "root",
})
export class CommunityService {
  constructor(private http: HttpClient) {}
  tableName = "community";
  community: Community = new Community();
  communities: Community[] = [];
  communitiesFilter: Community[] = [];
  loadingSpinner: boolean = false;

  public idNavination: number;

  public getIdNavigation() {
    let id = this.idNavination;
    this.idNavination = null;
    return id;
  }

  unreadCommunities: BehaviorSubject<Community[]> = new BehaviorSubject<Community[]>(null);

  getComunitiesType(type: number) {
    return this.http.get(url + "community?type=" + type);
  }

  createCommunity(fileData: any) {
    return this.http.post(url + "community", fileData);
  }

  getcommunities(requestParams?: getCommunityModel) {
    let params = new HttpParams();

    if(requestParams.limit) {
      params = params.set("limit", requestParams.limit.toString());
    }
    if (requestParams.order) {
      params = params.set("order", requestParams.order);
    }
    if (requestParams.home) {
      params = params.set("home", requestParams.home);
    }
    if (requestParams.type) {
      params = params.set("type", requestParams.type);
    }
    if (requestParams.fromPublishDate) {
      params = params.set("fromPublishDate", requestParams.fromPublishDate.toISOString());
    }
    if (requestParams?.read !== undefined) {
      params = params.set("read", requestParams.read.toString());
    }
    return this.http.get(url + "community", { params: params });
  }

  getCommunity(id: number) {
    return this.http.get(url + "community/" + id);
  }

  updateCommunity(fileData: any) {
    return this.http.put(url + "community/" + this.community.id, fileData);
  }

  deleteCommunity(id: number) {
    return this.http.delete(url + "community/" + id);
  }

  refreshCommunity(type: number) {
    this.loadingSpinner = true;
    this.communities = [];
    this.getComunitiesType(type).subscribe((res: Community[]) => {
      this.communities = res;
      this.communitiesFilter = res;
      this.loadingSpinner = false;
    });
  }

  loadCommunity(id: number) {
    this.community = new Community();
    this.getCommunity(id).subscribe((res: Community) => {
      this.community = res;
    });
  }

  generateDescription(dto: CreateDescriptionDto) {
    return this.http.post(url + "community/generate-description", dto);
  }

  markAsRead(ids: number[]) {
    return this.http.post<Community[]>(url + "community/mark-as-read", {
      idCommunity: ids,
    });
  }

  /**
   * Loads unread communities of a specific type and module.
   * @param CommunityType The type of community to filter by.
   * @param module The app module to filter by.
   */
  getUnreadCommunities(CommunityType: CommunityType, module: AppModule) {
    const params: getCommunityModel = {
      type: CommunityType,
      read: false,
    }

    this.getcommunities(params).subscribe({
      next: (res: Community[]) => {
        this.unreadCommunities.next(res);
        // Find page based on module and set count
        this.updateUnreadCommunities(
          module, 
          Array.isArray(res) ? res.length : null
        );
      },
    })
  }

  /**
   * Updates the count of unread communities for a specific module.
   * @param module The app module to filter by.
   * @param indicator The number of unread communities.
   */
  updateUnreadCommunities(module: AppModule, indicator: number) { 
    let pagesAll: any[] = Modules ? Modules.filter((p) => p.module >= 0) : null;
  
    if (pagesAll && Array.isArray(pagesAll)) {
      const foundPage = pagesAll.find(
        page => page.module === module
      );
      if (foundPage) {
        foundPage.count = indicator;
      }
    }
  }

}
